export default "__VITE_ASSET___QFXcqFg__"